import { MantineProvider, VariantColorsResolver, defaultVariantColorsResolver } from '@mantine/core';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { SandboxUiContext } from '../utils';
import { PopoverController } from './ControllerPopover/PopoverController';

const queryClient = new QueryClient();

type SandboxControllerProps = {
  companyToken: string;
  partnerToken: string;
  companyId: string;
  rerenderCta: () => Promise<void>;
};

const variantColorResolver: VariantColorsResolver = (input) => {
  if (input.variant === 'secondary') {
    return {
      background: '#FAFAFE',
      color: '#353A71',
      border: 'calc(0.0625rem * var(--mantine-scale)) solid #E8EAF9',
      hover: '#FAFAFE',
    };
  }

  if (input.variant === 'primary') {
    return {
      background: '#313347',
      color: '#FAFAFE',
      border: 'calc(0.0625rem * var(--mantine-scale)) solid #313347',
      hover: '#252636ff',
    };
  }

  return defaultVariantColorsResolver(input);
};

// Prevents iOS auto-zoom on mobile devices
const componentStyles = {
  InputWrapper: {
    styles: {
      label: {
        fontSize: 16,
      },
    },
  },
  Input: {
    styles: {
      input: {
        fontSize: 16,
      },
    },
  },
};

export const SandboxController = ({ companyToken, partnerToken, companyId, rerenderCta }: SandboxControllerProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <SandboxUiContext.Provider value={{ partnerToken, companyToken, rerenderCta, companyId }}>
        <MantineProvider theme={{ variantColorResolver, components: componentStyles }}>
          <PopoverController />
        </MantineProvider>
      </SandboxUiContext.Provider>
    </QueryClientProvider>
  );
};
